export default {
  'debit.neverForget': 'Say goodbye to the hassle of\nforgetting your bills!',
  'debit.signUp':
    'Sign up online now and effortlessly start your auto debit service!',
  'debit.GetYouBill':
    "Effortlessly pay your mobile bill each month with our Auto Debit service, which automatically deducts the amount from your credit card. It's the simplest way to stay on top of your payments.",
  'debit.step1': 'Step 1',
  'debit.step2': 'Step 2',
  'debit.step3': 'Step 3',
  'debit.step1Text': 'Click the button below to enroll in Auto Debit.',
  'debit.step2Text': 'Enter your personal details and credit card information.',
  'debit.step3Text': "Upon success, you'll receive a confirmation from us.",
  'debit.note':
    'Please note that a temporary hold of $1.00 will be placed on your debit/credit card to verify its validity. This amount will be refunded to your account within a few days.',
  'debit.letsGo': 'Go and Subscribe',
  'debit.alreadysianed':
    'Have you registered for the automatic debit service? Click the button above to',
  'debit.footer':
    'update or change your automatic debit subscription settings.',
};
